(function() {
    $(document).ready(function() {
        'use strict';

        var $siteHeader = $('.js-site-header'),
            $siteLogo = $siteHeader.find('.js-site-logo'),
            siteHeaderHeight = $siteHeader.find('.site-layout-wrapper').outerHeight(),
            windowHeight = helperUtils.getDocDimen().height,
            offsetAnimation = 0.3,

            headerOffset = windowHeight * offsetAnimation,
            pinnedState = false,
            unPinnedState = false,
            pinnedClass = 'is-pinned',
            unPinnedClass = 'is-unpinned',
            pageOffset,
            rAFTicker = false;

            //if this isn't homepage, do not animate header
            if($('.page--home').length === 0) {
                headerOffset = 0;
                offsetAnimation = 0;
            }

        function attachScrollEvent() {
            // only listen for scroll events
            window.addEventListener('scroll', requestTicker, false);
        }

        function removeScrollEvent() {
            //remove ScrollEvent
            window.removeEventListener('scroll', requestTicker, false);
        }

        function requestTicker() {
            if (!rAFTicker) {
                requestAnimationFrame(windowScrollLogic);
                rAFTicker = true;
            }
        }

        function windowScrollLogic(){
            pageOffset = window.pageYOffset;

            if( pageOffset >  siteHeaderHeight ) {

                $siteHeader.addClass('is-prep-pinned');


                if( pageOffset >  headerOffset ) {
                    $siteHeader
                        .addClass(pinnedClass)
                        .removeClass(unPinnedClass);

                    pinnedState = true;
                }
                else {

                    if(pinnedState) {
                        $siteHeader
                            .addClass(unPinnedClass);
                        unPinnedState = true;
                    }

                    $siteHeader.removeClass(pinnedClass);
                    pinnedState = false;
                }

            }

            else {
                $siteHeader.removeClass(unPinnedClass);
                $siteHeader.removeClass(pinnedClass);
                unPinnedState = false;
                pinnedState = false;
                $siteHeader.removeClass('is-prep-pinned');
            }



            rAFTicker = false;
        }

        attachScrollEvent();



//Append dark version of logo

        var $imgHtml = $('<img class="site-brand__logo--dark" src="' + $siteLogo.data('img-dark') + '" alt="babc" />');

        $siteLogo.parent().append($imgHtml);



// will moving this to a factory module
//window.addEventListener("resize", resizeThrottler, false);

// var resizeTimeout;
// function resizeThrottler() {
// 	// ignore resize events as long as an actualResizeHandler execution is in the queue
// 	if ( !resizeTimeout ) {
// 		resizeTimeout = setTimeout(function() {
// 			resizeTimeout = null;
// 			stickyFeatureCheck();

// 			// The actualResizeHandler will execute at a rate of 15fps
// 		}, 66);
// 	}
// }
    });
})();